import * as React from 'react';
import { Query } from 'react-apollo';

import AdminDistrictSisDashboardContainer from 'admin/rostering/containers/AdminDistrictSisDashboardContainer';
import AdminSchoolSisDashboard from 'admin/rostering/components/AdminSchoolSisDashboard';
import AdminStartSisSyncSetupContainer from 'admin/rostering/containers/AdminStartSisSyncSetupContainer';
import ErrorReporter from 'app/components/ErrorReporter';
import LoadingIndicator from 'components/LoadingIndicator';

import ADMIN_SIS_DASHBOARD_QUERY from 'admin/rostering/queries/AdminSisDashboardQuery.gql';

import {
  AdminSisDashboard as AdminSchoolSisDashboard_Data,
  AdminSisDashboardVariables,
} from 'admin/rostering/queries/__generated__/AdminSisDashboard';

import { SyncType } from 'globalTypes';
import { findMatching } from 'utils/arrayHelpers';

type Props = {
  orgId: number;
};

export default class AdminSisDashboardContainer extends React.Component<Props> {
  render() {
    const { orgId } = this.props;
    const queryVars = { organizationIds: [orgId] };

    return (
      <Query<AdminSchoolSisDashboard_Data, AdminSisDashboardVariables>
        query={ADMIN_SIS_DASHBOARD_QUERY}
        variables={queryVars}>
        {({ data, error, loading, refetch }) => {
          if (loading) {
            return <LoadingIndicator height={400} size="small" />;
          }

          if (error || !data?.organizations) {
            return (
              <ErrorReporter error={error || 'AdminSisDashboardContainer - could not load data'} />
            );
          }

          const organization = findMatching(data.organizations, orgId, 'id');

          if (!organization) {
            return (
              <ErrorReporter
                error={'AdminSisDashboardContainer - expected the provided org to be in the result'}
              />
            );
          }

          const canSeeDashboard = organization.permissions.adminConsole.seeRosteringTab;

          if (!canSeeDashboard) {
            return (
              <ErrorReporter error={'SIS management page - non-paid accounts should not be here'}>
                <span data-test="non-paid">
                  Uh, oh. You should not be here, something weird happened.
                </span>
              </ErrorReporter>
            );
          }

          if (organization.type === 'District') {
            const { districtStatus } = organization.sisSyncOverview;

            if (!districtStatus) {
              return (
                <ErrorReporter
                  error={
                    'AdminSisDashboardContainer - expected the district status to be in the result'
                  }
                />
              );
            }

            if (districtStatus.syncType === SyncType.none) {
              return (
                <AdminStartSisSyncSetupContainer
                  orgUuid={organization.uuid}
                  orgName={organization.name}
                  updateCallback={refetch}
                />
              );
            } else {
              return <AdminDistrictSisDashboardContainer orgId={organization.id} />;
            }
          } else {
            // School
            return <AdminSchoolSisDashboard loading={loading} orgUuid={organization.uuid} />;
          }
        }}
      </Query>
    );
  }
}
